import React from 'react';
import { specializationsPhone } from './constants';
import { SpecializationsMobile } from './SpecializationsMobile';

export const SpecializationsPhone = () => {
    return <SpecializationsMobile specializations={specializationsPhone} />;
};
